<template>
  <div class="dropdown-tab">
    <div
      :class="{
        'dropdown-box': true,
        bg_white: bgColor == 'white',
        bg_grey: bgColor == 'grey',
        bg_black: bgColor == 'black',
        active: (current_selected.name == item.name) && item.drop.show,
        box_border: dropBorder
      }"
      @click="(item.drop.show = !item.drop.show), $emit('selected', item)"
    >
      <label for="" class="mb-0 w-100 arrow">{{ item.name }}</label>
    </div>
    <CollapseTransition v-show="item.drop.show" :duration="200">
      <div
        :class="{
          'info mb-0': true,
          active: (current_selected.name == item.name) && item.drop.show,
          box_border: dropBorder
        }
      ">
        <div
          v-for="(el, index) in item.drop.info"
          :key="index"
        >
          <label v-if="el.title?.length > 0" class="mb-3">{{ el.title }}</label>
          <p v-if="el.text?.length > 0" class="mb-4">{{ el.text }}</p>
          <ul>
            <li v-for="(li, idx) in el.list" :key="idx">
              <label class="d-block mb-1" v-if="li.title?.length > 0">{{ li.title }}</label>
              <span v-if="li.text?.length > 0">{{ li.text }}</span>
              <div v-if="li.list?.length > 0" class="info_box bg_grey mt-3 mr-3">
                <ul>
                  <li v-for="(ele, inx) in li.list" :key="inx">
                    <label v-if="ele.title?.length > 0">{{ ele.title }}</label>
                    <span v-if="ele.text?.length > 0" class="text_sm">{{ ele.text }}</span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </CollapseTransition>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  components: {
    CollapseTransition
  },
  props: {
    label: {
      type: String,
      default: () => ""
    },
    item: {
      type: Object,
      default: () => {}
    },
    bgColor: {
      type: String,
      default: () => 'white'
    },
    current_selected: {
      type: Object,
      default: () => {}
    },
    dropBorder: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {

    }
  },
  watch: {
    current_selected(val) {
      // auto close with change tab
      if (val.name != this.item.name) this.item.drop.show = false;
    }
  }
}
</script>

<style scoped>
.dropdown-tab {
  width: 100%;
  position: relative;
  cursor: pointer;
}
.dropdown-tab .dropdown-box {
  width: 100%;
  height: 65px;
  min-height: 65px;
  display: flex;
  align-items: center;
  padding: 1rem;
  margin: auto 0;
  border-bottom: 1px solid #e8e8e8;
}
.dropdown-tab .info {
  padding: 1rem;
  background-color: #fff;
}
.dropdown-tab .info.active {
  border-bottom: 1px solid #e8e8e8;
}
.dropdown-tab .info.active.box_border {
  border: 1px solid #e8e8e8;
  border-top: 0;
}
.dropdown-tab .info ul li {
  margin-bottom: .75rem;
}
.dropdown-tab .info ul li:last-child {
  margin-bottom: 0;
}
.dropdown-tab .dropdown-box:hover {
  transition: .25s;
  /* border-radius: 1rem; */
  background-color: #f2f2f2;
}
.dropdown-tab .dropdown-box:focus {
  background-color: #e8e8e8;
}
.dropdown-tab .dropdown-box.active {
  background-color: #fff;
  border-bottom: 0;
}
.dropdown-tab .dropdown-box.active.box_border {
  border: 1px solid #e8e8e8;
  border-bottom: 0;
}
</style>